import AccountReceivableListModal from '@/components/_common/AccountReceivableListModal';
import {
  StatisticDashboardModule,
  StatisticDashboardTypeColor,
} from '@/components/_common/StatisticDashboard';
import { AccountReceivableSituation } from '@/core/domain/financial/AccountReceivable/AccountReceivable.types';
import { useDisclosure } from '@/hooks';
import { DateTimeFormat } from '@/utils/moment';
import moment from 'moment';
import DashboardStatisticCard from '../../DashboardStatisticCard';

interface Props {
  value?: number;
}
function ReceivableOverdue({ value }: Props) {
  const [viewAccountReceivablesOpen, viewAccountReceivablesActions] =
    useDisclosure();

  return (
    <>
      <DashboardStatisticCard
        tooltipTitle="Quantidade de parcelas do contas a receber com data de vencimento anterior ao dia atual que ainda está com situação em aberto."
        statisticTitle="A receber vencidas | Qtde."
        color={StatisticDashboardTypeColor.info}
        value={value}
        module={StatisticDashboardModule.accountReceivable}
        onClick={viewAccountReceivablesActions.open}
      />

      <AccountReceivableListModal
        open={viewAccountReceivablesOpen}
        onCancel={viewAccountReceivablesActions.close}
        queryFilter={{
          situation: AccountReceivableSituation.open,
          finalDueDate: moment().subtract(1, 'day').format(DateTimeFormat),
        }}
      />
    </>
  );
}

export default ReceivableOverdue;
